import {Component, Input, OnInit} from '@angular/core';
import {Toast, ToastService} from '../../../services/toast.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styles: []
})
export class NotificationComponent implements OnInit {
  @Input() toast: Toast;
  timeout: any;
  dismissKey: number;
  dismissValue: number;
  toState: string;

  constructor(private toastService: ToastService) {
  }

  close() {
    clearTimeout(this.timeout);
    this.toastService.DismissNotification(this.toast);

    if (this.toast.OnDismissed !== null) {
      this.toast.State = 'dismissed';

      this.toast.OnDismissed();
    }
  }

  onMouseEnter(e: Event) {
    if (!this.toast.Config.AutoDismiss) {
      return;
    }
    this.dismissValue--;
    clearTimeout(this.timeout);
  }

  onMouseLeave(e: Event) {
    if (!this.toast.Config.AutoDismiss) {
      return;
    }

    this.createTimer();
  }

  createTimer() {
    const that = this;
    this.dismissKey++;
    this.dismissValue = this.dismissKey;

    window.setTimeout(() => {
      if (that.dismissKey !== that.dismissValue) {
        return;
      }

      this.toastService.DismissNotification(this.toast);
    }, this.toast.Config.DismissedAfter * 1000);

  }

  ngOnInit() {
    this.dismissKey = 0;
    this.dismissValue = 0;
    if (this.toast.Config.AutoDismiss) {
      this.createTimer();
    }
    this.toast.State = 'active';
  }
}
